import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PagesViewConfigCoreRoutingModule } from './pages-view-config-core-routing.module';
import { PageViewConfigPresorteoComponent } from './page-view-config-presorteo/page-view-config-presorteo.component';
import { ViewConfigModule } from '../../components/view-config/view-config.module';


@NgModule({
  declarations: [
    PageViewConfigPresorteoComponent
  ],
  imports: [
    CommonModule,
    PagesViewConfigCoreRoutingModule,
    ViewConfigModule
  ]
})
export class PagesViewConfigCoreModule { }
